import permissions from '../../permissions'

const INCIDENT_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.VISUALIZE,
    tag: permissions.INCIDENTS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.INCIDENTS.CREATE,
  },
  {
    name: permissions.PERMISSIONS_INCIDENTS_LABEL.INACTIVATE,
    tag: permissions.INCIDENTS.INACTIVATE,
  },
]

export default INCIDENT_LIST
